// extracted by mini-css-extract-plugin
export default {"Chat":"Chat_Chat__JTGaV","Alert":"Chat_Alert__xh+SP","Body":"Chat_Body__3ecnL","ScrollWrapper":"Chat_ScrollWrapper__95ttL","Scroll":"Chat_Scroll__DwgWG"};